import React from 'react';
import Plan from '../../components/plan_comp/planui'; 

const PlanPage = () => {
    return (
        <main >
            <Plan />
        </main>
    );
};

export default PlanPage;
